export const project_information_table_header = [
  { label: 'Client', value: 0 },
  { label: 'Code', value: 1 },
  { label: 'Name', value: 2 },
  { label: 'Type', value: 3 },
  { label: 'LOB', value: 4 },
  { label: 'Start Date', value: 5 },
  { label: 'End Date', value: 6 },
  { label: 'Key PM', value: 7 },
  { label: 'Created', value: 8 },
  { label: 'Status', value: 9 },
]

export const project_status = [
  { label: 'All Project Status', value: '' },
  { label: 'Pre-sale', value: 'Presale' },
  { label: 'Implementing', value: 'Implementing' },
  { label: 'Done', value: 'Done' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
]

export const project_type = [
  { label: 'Fixed-Fee', value: 'FIXFEE' },
  { label: 'Time Material', value: 'TIME_MATERIAL' },
  { label: 'Support', value: 'SUPPORT' },
  { label: 'Internal', value: 'SPECIFIC' },
  { label: 'Common', value: 'COMMON' },
  { label: 'IAM Product', value: 'IAM_PRODUCT' },
  { label: 'Cloud', value: 'CLOUD' },
]

export const license_type = [
  { label: 'MA', value: 'LICENSE_MA' },
  { label: 'License', value: 'LICENSE' },
  { label: 'Subscription', value: 'SUBSCRIPTION' },
]

export const licensing_table_header = [
  { label: 'Type', value: 0 },
  { label: 'Sub-Project Code', value: 1 },
  { label: 'License Name', value: 2 },
  { label: 'Description', value: 3 },
  { label: 'Cost (฿)', value: 4 },
  { label: 'Price (฿)', value: 5 },
  { label: 'Action', value: 6 },
]

export const hardware_type = [
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'MA', value: 'HARDWARE_MA' },
]

export const hardware_table_header = [
  { label: 'Type', value: 0 },
  { label: 'Sub-Project Code', value: 1 },
  { label: 'Hardware Name', value: 2 },
  { label: 'Description', value: 3 },
  { label: 'Cost (฿)', value: 4 },
  { label: 'Price (฿)', value: 5 },
  { label: 'Action', value: 6 },
]

export const vendor_cost_table_header = [
  { label: 'Sub-Project Code', value: 0 },
  { label: 'Other Service Name', value: 1 },
  { label: 'Description', value: 2 },
  { label: 'Cost (฿)', value: 3 },
  { label: 'Price (฿)', value: 4 },
  { label: 'Man-Day(s)', value: 5 },
  { label: 'Action', value: 6 },
]

export const change_request_table_header = [
  { label: 'QT/PO No.', value: 0 },
  { label: 'Change Request', value: 1 },
  { label: 'Description', value: 2 },
  { label: 'Man-Days', value: 3 },
  { label: 'Price (฿)', value: 4 },
  { label: 'Action', value: 5 },
]

export const attachment_table_header = [
  { label: 'Name', value: 0 },
  { label: 'Description', value: 1 },
  { label: 'Uploaded By', value: 2 },
  { label: 'Uploaded Date', value: 3 },
  { label: 'Action', value: 4 },
]

export const project_revenue_table_header = {
  column: [
    '',
    'List Price (A)',
    'Min Price (B)',
    'Contract Price (C)',
    'Diff. List Price (D = C - A)',
    'CR Price (E)',
    'Current Version (Forecast from PPS)',
    'Latest Approved (Forecast from PPS)',
  ],
  row: [
    'Revenue',
    'Total Cost',
    'Gross Profit',
    'Gross Profit Ratio',
    'GP/MD',
    'SGA Allocation',
    'OI',
    'OI%',
  ],
}

export const expenditure_summary_table_header = {
  column: [
    'Type',
    'Man-Day(s)',
    'Man-Day(s) Ratio',
    'Average Man-Day Rate (฿)',
    'Cost (฿)',
  ],
  row: [
    'Employee',
    'Sub-Contractor',
    'Other Service',
    'License/MA',
    'Hardware',
    'Other',
  ],
}

export const COMMON = 'COMMON'
export const SUPPORT = 'SUPPORT'
export const PRESALE = 'PRESALE'
export const IMPLEMENTING = 'IMPLEMENTING'
export const DONE = 'DONE'
export const INACTIVE = 'INACTIVE'
export const NONSUMMIT = 'NONSUMMIT'
export const REJECTED = 'REJECTED'
export const PENDING = 'PENDING'



// WEBPACK FOOTER //
// ./src/components/project-information/constants/index.js